/**
 * ModalErrorBanner
 *
 * Red banner for surface-level form errors inside shared Modal forms.
 * Renders nothing when `message` is falsy so callers can unconditionally
 * mount it without wrapping it in a ternary.
 *
 * Typography/tokens match the inline error banner CreateTicketModal used
 * before the migration so the visual diff is zero.
 */

import React from 'react'

interface ModalErrorBannerProps {
  message: string | null | undefined
  className?: string
  testId?: string
}

// Extracted to avoid duplicating the full token string for the "has extra
// className" branch; keeps the tokens in one place for future theme edits.
const BASE_CLASS = 'mb-4 p-3 bg-red-500/10 border border-red-500/30 rounded-lg'

export const ModalErrorBanner: React.FC<ModalErrorBannerProps> = React.memo(
  function ModalErrorBanner({ message, className, testId }) {
    if (!message) return null

    const wrapperClassName = className ? `${BASE_CLASS} ${className}` : BASE_CLASS

    return (
      <div role="alert" className={wrapperClassName} data-testid={testId}>
        <p className="text-sm text-red-400 [html[data-theme=light]_&]:text-red-700">{message}</p>
      </div>
    )
  },
)
